module.exports = __webpack_public_path__ + "img/panels_serial03.c9bf31bd.gif";